import React from 'react'
import {Modal} from 'react-bootstrap-v5'

type SessionExpiredModalProps = {
  show: boolean
  onLoginAgain: () => void
}

const SessionExpiredModal: React.FC<SessionExpiredModalProps> = ({show, onLoginAgain}) => (
  <Modal show={show} backdrop='static' keyboard={false} centered>
    <div className='modal-header border-0 pb-0'>
      <h5 className='modal-title'>Session Expired</h5>
    </div>
    <div className='modal-body pt-0'>
      <p className='mb-0 text-muted'>Your session has expired. Please log in again to continue.</p>
    </div>
    <div className='modal-footer border-0 pt-0'>
      <button type='button' className='btn btn-primary' onClick={onLoginAgain}>
        Log in again
      </button>
    </div>
  </Modal>
)

export default SessionExpiredModal
